(() => {
  document.querySelectorAll('.lr-trade-controls121').forEach(controls => {
    if (controls.dataset.ready) return;
    const rail = controls.parentElement.querySelector('.lr-trade70-grid');
    if (!rail) return;
    controls.dataset.ready = 'true';
    controls.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
      const card = rail.firstElementChild;
      const distance = card ? card.getBoundingClientRect().width + 18 : rail.clientWidth;
      rail.scrollBy({left: distance * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
  });
})();
